import {
  CreateResolutionNewWager,
  CreateResolutionProjection,
  ResolutionDetailsStep
} from '@bo-components/resolutions/resolutionDetails';
import type { ResolutionSetup } from '@library/types/resolutions/resolutionDetails';
import { useCreateResolutionConfiguration } from '@bo-hooks/resolutions/resolutionDetails';

export interface CreateResolutionConfigurationProps {
  resolutionSetup: ResolutionSetup;
}

export const CreateResolutionConfiguration = ({
  resolutionSetup
}: CreateResolutionConfigurationProps) => {
  const {
    isContinueDisabled,
    isError,
    onClickContinue,
    onResolutionFileChange,
    onResolutionFileDrop,
    onResolutionRemoveFile,
    onResolutionReasonChange,
    reasonCodeOptions,
    resolutionReason,
    resolutionFile,
    resolutionInputType
  } = useCreateResolutionConfiguration({ resolutionSetup });

  return (
    <ResolutionDetailsStep
      isDisabled={isContinueDisabled}
      onClickContinue={onClickContinue}
    >
      {resolutionInputType === 'new_wager' && (
        <CreateResolutionNewWager
          isError={isError}
          onResolutionFileChange={onResolutionFileChange}
          onResolutionFileDrop={onResolutionFileDrop}
          onResolutionReasonChange={onResolutionReasonChange}
          onResolutionRemoveFile={onResolutionRemoveFile}
          reasonCodeOptions={reasonCodeOptions}
          resolutionFile={resolutionFile}
          resolutionReason={resolutionReason || null}
        />
      )}

      {resolutionInputType === 'projection' && <CreateResolutionProjection />}
    </ResolutionDetailsStep>
  );
};
